export default __webpack_public_path__ + "static/media/mercedes-benz.425e55c8.svg";